module.exports = __webpack_public_path__ + "media/images/flags/16/Suriname-02e6b68f423db7f081f4f44c14dfd110.png";